module.exports = __webpack_public_path__ + "media/images/icons/close-a7b94b56af44f271f0b0cde6a0a4b25d.svg";